export const getAuthorizationHeader = (token?: string | null) => {
    token = token || getToken()
    if (!token) return undefined
    return { authorization: `Bearer ${token}` }
}

export const getToken = (): string | null => {
    return localStorage.getItem('token')
}

export const getRestApiConfig = () => {
    return {
        baseUrl: process.env.REACT_APP_API_HOST /*?? 'http://aktivace-api.beta.nexum.cz/', //process.env.REACT_APP_API_HOST!*/,
        authHeader: getAuthorizationHeader(),
    }
}
